
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Four04Component } from 'src/app/four04/four04.component';
import { FACEBOOK_PIXEL_PROVIDER } from '../shared/services/facebook-pixel.provider'
import { HomeComponent } from './home.component';
const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  { path: '**', component: Four04Component }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    FACEBOOK_PIXEL_PROVIDER
  ]
})
export class HomeRoutingModule { }

